// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Haptics } from "@capacitor/haptics";
import {
  HoldToConfirmButton as HoldToConfirmButtonBase,
  type HoldToConfirmButtonProps as HoldToConfirmButtonPropsBase,
} from "@clipboard-health/ui-components";
import { isCapacitorPlatform } from "@src/appV2/lib";

import { ButtonInternalLink } from "./ButtonInternalLink";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface HoldToConfirmButtonProps extends Omit<HoldToConfirmButtonPropsBase, "LinkComponent"> {}

export function HoldToConfirmButton(props: HoldToConfirmButtonProps) {
  return (
    <HoldToConfirmButtonBase
      {...props}
      LinkComponent={ButtonInternalLink}
      onConfirmStart={() => {
        if (isCapacitorPlatform()) {
          void Haptics.selectionStart();
        }

        props.onConfirmStart?.();
      }}
      onConfirmEnd={() => {
        if (isCapacitorPlatform()) {
          void Haptics.selectionEnd();
        }

        props.onConfirmEnd?.();
      }}
    />
  );
}
